
enum FeaturePermissionTypeCodes {
  CALL_CENTER_INCLUSION = "CALL_CENTER_INCLUSION",
};

export default FeaturePermissionTypeCodes;